"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _axios = _interopRequireDefault(require("axios"));
var _core = require("core.ui-module_site-components");
var _ApplicationContext = require("../../api/ApplicationContext");
var _TermsAndConditionsStepResponse = _interopRequireDefault(require("../../api/auth/TermsAndConditionsStepResponse"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class TermsAndConditionsStep extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onAccept", e => {
      const {
        done,
        terms,
        termsIndex
      } = this.state;
      e.preventDefault();
      if (!done) {
        if (!terms || terms.length === 0) {
          this.setState({
            errorMessage: '',
            done: true,
            currentTerm: null,
            isLoading: true,
            disableButtons: true
          });
          const step = new _TermsAndConditionsStepResponse.default();
          step.acceptDecline = 'A';
          this.props.listener(this, step);
        } else {
          this.setState({
            done: false,
            currentTerm: terms.shift(),
            isLoading: false,
            termsIndex: termsIndex + 1
          });
        }
      }
    });
    _defineProperty(this, "onClose", e => {
      e.preventDefault();
      this.setState({
        errorMessage: '',
        isLoading: true
      });
      window.location.href = _ApplicationContext.ApplicationContext.getLoginPath();
    });
    _defineProperty(this, "onCancel", e => {
      e.preventDefault();
      this.setState({
        errorMessage: '',
        done: true,
        currentTerm: null,
        isLoading: true
      });
      const step = new _TermsAndConditionsStepResponse.default();
      step.acceptDecline = 'D';
      this.props.listener(this, step);
    });
    _defineProperty(this, "showFullText", () => {
      this.setState({
        isShowFullText: true
      });
    });
    _defineProperty(this, "hideFullText", () => {
      this.setState({
        isShowFullText: false
      });
    });
    this.consultantChild = /*#__PURE__*/_react.default.createRef();
    this.state = {
      done: false,
      isLoading: true,
      terms: undefined,
      currentTerm: null,
      termsCount: 0,
      termsIndex: 0,
      showFullText: false,
      TextExpanded: false,
      errorMessage: '',
      additionalData: null,
      disableButtons: true
    };
    this.el = document.createElement('div');
    this.el.style.display = 'contents';
  }
  componentDidMount() {
    document.body.appendChild(this.el);
    const request = _axios.default.create({
      baseURL: _ApplicationContext.ApplicationContext.getApiBasePath()
    });
    request.get('/application/consultant/legal-user-agreement/terms-and-conditions').then(response => {
      const terms = response.data;
      if (terms && terms.length > 0) {
        const termsCount = terms.length;
        this.setState({
          isLoading: false,
          currentTerm: terms.shift(),
          terms,
          termsCount,
          termsIndex: 1,
          disableButtons: false
        });
      } else {
        this.setState({
          isLoading: false,
          disableButtons: false
        });
      }
    }).catch(() => {
      this.setState({
        isLoading: false,
        disableButtons: false
      });
    });
  }
  componentWillUnmount() {
    document.body.removeChild(this.el);
  }
  termsContent() {
    const {
      legalText
    } = this.props;
    const {
      done,
      currentTerm,
      isLoading,
      termsIndex,
      termsCount,
      isShowFullText
    } = this.state;
    let termText = '';
    if (currentTerm && currentTerm.textLong) {
      termText = _dompurify.default.sanitize(currentTerm.textLong);
    }
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, done || isLoading ? /*#__PURE__*/_react.default.createElement("div", {
      className: "is-full-width has-text-centered"
    }, /*#__PURE__*/_react.default.createElement(_core.Spinner, null)) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null, termsCount > 1 && /*#__PURE__*/_react.default.createElement("div", {
      className: "columns is-marginless"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "column"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "is-pulled-right"
    }, termsIndex, " of ", termsCount))), /*#__PURE__*/_react.default.createElement("div", {
      className: "columns is-vcentered is-marginless "
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "column is-paddingless has-text-left"
    }, /*#__PURE__*/_react.default.createElement("p", {
      dangerouslySetInnerHTML: {
        __html: termText
      }
    }), termsIndex === termsCount && /*#__PURE__*/_react.default.createElement("div", {
      className: "table box is-vcentered"
    }, isShowFullText ? /*#__PURE__*/_react.default.createElement("p", {
      onClick: this.hideFullText
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons table-nested--trigger"
    }, "expand_less"), ' ', /*#__PURE__*/_react.default.createElement("b", {
      className: "has-text-link"
    }, "By accessing this site, I agree to abide by the site\u2019s full Terms of Use.")) : /*#__PURE__*/_react.default.createElement("p", {
      onClick: this.showFullText
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons table-nested--trigger"
    }, "expand_more"), ' ', /*#__PURE__*/_react.default.createElement("b", {
      className: "has-text-link"
    }, "By accessing this site, I agree to abide by the site\u2019s full Terms of Use.")), isShowFullText && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("hr", null), legalText)))))));
  }
  render() {
    const {
      disableButtons,
      errorMessage,
      isLoading
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: `lds-spinner-overlay ${isLoading && 'is-active'}`
    }, isLoading && /*#__PURE__*/_react.default.createElement(_core.Spinner, null)), /*#__PURE__*/_react.default.createElement(_core.OkModal, {
      header: "Authentication Failed",
      message: errorMessage,
      display: errorMessage !== '',
      key: errorMessage
    }), /*#__PURE__*/_react.default.createElement(_core.Modal, {
      showCloseIcon: true,
      darkBackground: true,
      closeModalCallback: this.onClose,
      footer: /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
        className: "is-primary fixedButtonSize",
        handleClick: this.onCancel
      }, "Cancel"), /*#__PURE__*/_react.default.createElement(_core.Button, {
        className: "is-primary is-pulled-right fixedButtonSize",
        handleClick: this.onAccept,
        disabled: disableButtons
      }, "I Accept")),
      header: "Terms and Conditions"
    }, /*#__PURE__*/_react.default.createElement("div", null, this.termsContent())));
  }
}
TermsAndConditionsStep.propTypes = {
  listener: _propTypes.default.func.isRequired,
  stepResponse: _propTypes.default.any,
  history: _propTypes.default.any,
  legalText: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object])
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(TermsAndConditionsStep);
//# sourceMappingURL=TermsAndConditionsStep.js.map